import React, { useEffect, useState } from "react";
import './Exepciones.scss'
import GlovalCard from "../../../components/atoms/GlovalCard/GlovalCard";
import TitleView from "../../../components/atoms/TitleView/TitleView";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import InputLista from "../../../components/atoms/InputLista/InputLista";
import InputText from "../../../components/atoms/InputText/InputText";
import TextArea from "../../../components/atoms/TextArea/TextArea";
import Button from "../../../components/atoms/Button/Button";
import { extraerHoraDate, formateoBasico, invertirFormatoFecha } from "../../../utilities/formateos";
import { getClients } from "../../monitoreo/MonitoreoServicios/MonitoreoServiciosIntegracion";
import { transferisServiciosIntegracion } from "../../monitoreo/TransferirServicios/transferisServiciosIntegracion";
import { createNewExcepcion, getProveedoresAliados, getTipoUnidad } from "./ExcepcionesIntegracion";
import Swal from "sweetalert2";
import useGetDataUser from "../../../CustomHooks/useGetDataUser";


const Exepciones = () => {
    const dataUser = useGetDataUser()
    const [fecha, setFecha] = useState()
    const [clientes, setClientes] = useState([])
    const [cliente, setCliente] = useState(null)
    const [rutas, setRutas] = useState([])
    const [ruta, setRuta] = useState(null)
    const [estructuras, setEstructuras] = useState([])
    const [estructura, setEstructura] = useState(null)
    const [estructuraSalida, setEstructuraSalida] = useState(null)
    const [horaInicio, setHoraInicio] = useState(extraerHoraDate(new Date()))
    const [horaFin, setHoraFin] = useState(extraerHoraDate(new Date()))
    const [tipoUnidades, setTipoUnidades] = useState([])
    const [tipoUnidad, setTipoUnidad] = useState(null)
    const [proveedores, setProveedores] = useState([])
    const [proveedor, setProveedor] = useState(null)
    const [operadores, setOperadores] = useState([])
    const [operador, setOperador] = useState(null)
    const [motivo, setMotivo] = useState(null)
    const [exito, setExito] = useState(false)
    const [tipo, setTipo] = useState('Sencillo')
    const [requeridoCliente, setRequeridoCliente] = useState('si')
    const [confirmacion, setConfirmacion] = useState(null)

    useEffect(() => {
        // setFecha(formateoBasico(new Date()))
        setFecha()
        getClients(setClientes)
        setProveedor({ name: "SUMA TE LLEVA", code: 1 })
        getTipoUnidad(setTipoUnidades)
        getProveedoresAliados(setProveedores)
        transferisServiciosIntegracion.getOperadores(setOperadores)
    }, [])
    useEffect(() => {
        if (cliente) {
            transferisServiciosIntegracion.getRutesByIdClient(cliente.code, setRutas)
        }
    }, [cliente])
    useEffect(() => {
        if (ruta) {
            transferisServiciosIntegracion.getEstructuraByRuta(ruta.code, setEstructuras)
        }
    }, [ruta])
    useEffect(() => {
        if (estructura) {
            setHoraInicio(estructura.HORA_INICIO[1])
            setHoraFin(estructura.HORA_FIN)
        }
    }, [estructura])
    useEffect(() => {
        setEstructuraSalida(null)
    }, [tipo])
    const submit = () => {
     
     
       

        if (tipo == 'Medio') {
            if (fecha && ruta && horaInicio && horaFin && tipo && estructura && cliente && tipoUnidad && motivo && estructuraSalida) {
                if (proveedor.code == 1) {
                    if (operador) {

                        const data = {
                            id_usuario: dataUser.ID,
                            fecha: fecha,
                            id_ruta: ruta.code,
                            hora_arranque: fecha + " " + horaInicio,
                            hora_llegada: fecha + " " + horaFin,
                            tipo: tipo,
                            estructura_salida: tipo == 'Sencillo' ? null : estructuraSalida?.code,
                            id_ruta_estructura: estructura.code,
                            id_proveedor: proveedor.code,
                            cliente: cliente.code,
                            id_chofer: operador.code,
                            tipo_unidad_ex: tipoUnidad.code,
                            comentarios: motivo + " - VMH",
                            requerido_Cliente:requeridoCliente
                        }
                        confirmarTipoDeViaje(tipo, () => {
                            createNewExcepcion(data,limpiar)
                        })

                    }

                }
                else {

                    const data = {
                        id_usuario: dataUser.ID,
                        fecha: fecha,
                        id_ruta: ruta.code,
                        hora_arranque: fecha + " " + horaInicio,
                        hora_llegada: fecha + " " + horaFin,
                        tipo: tipo,
                        id_ruta_estructura: estructura.code,
                        estructura_salida: tipo == 'Sencillo' ? null : estructuraSalida?.code,
                        id_proveedor: proveedor.code,
                        cliente: cliente.code,
                        id_chofer: null,
                        tipo_unidad_ex: tipoUnidad.code,
                        comentarios: motivo + " - VMH",
                        requerido_Cliente:requeridoCliente
                    }
                    confirmarTipoDeViaje(tipo, () => {
                        createNewExcepcion(data,limpiar)
                    })


                }
            }
            else {
                Swal.fire({
                    icon: 'error',   // Icono de error
                    title: 'Oops...', // Título de la alerta
                    text: 'Rellena todos los campos obligatorios', // Mensaje de error
                    confirmButtonText: 'OK'  // Texto del botón de confirmación
                });
            }
        }
        else {
            if (fecha && ruta && horaInicio && horaFin && tipo && estructura && cliente && tipoUnidad && motivo) {
                if (proveedor.code == 1) {
                    if (operador) {

                        const data = {
                            id_usuario: dataUser.ID,
                            fecha: fecha,
                            id_ruta: ruta.code,
                            hora_arranque: fecha + " " + horaInicio,
                            hora_llegada: fecha + " " + horaFin,
                            tipo: tipo,
                            estructura_salida: tipo == 'Sencillo' ? null : estructuraSalida?.code,
                            id_ruta_estructura: estructura.code,
                            id_proveedor: proveedor.code,
                            cliente: cliente.code,
                            id_chofer: operador.code,
                            tipo_unidad_ex: tipoUnidad.code,
                            comentarios: motivo + " - VMH",
                            requerido_Cliente:requeridoCliente
                        }

                        confirmarTipoDeViaje(tipo, () => {
                            createNewExcepcion(data,limpiar)
                        })
                    }

                }
                else {

                    const data = {
                        id_usuario: dataUser.ID,
                        fecha: fecha,
                        id_ruta: ruta.code,
                        hora_arranque: fecha + " " + horaInicio,
                        hora_llegada: fecha + " " + horaFin,
                        tipo: tipo,
                        id_ruta_estructura: estructura.code,
                        estructura_salida: tipo == 'Sencillo' ? null : estructuraSalida?.code,
                        id_proveedor: proveedor.code,
                        cliente: cliente.code,
                        id_chofer: null,
                        tipo_unidad_ex: tipoUnidad.code,
                        comentarios: motivo + " - VMH",
                        requerido_Cliente:requeridoCliente
                    }
                    confirmarTipoDeViaje(tipo, () => {
                        createNewExcepcion(data,limpiar)
                    })


                }
            }
            else {
                Swal.fire({
                    icon: 'error',   // Icono de error
                    title: 'Oops...', // Título de la alerta
                    text: 'Rellena todos los campos obligatorios', // Mensaje de error
                    confirmButtonText: 'OK'  // Texto del botón de confirmación
                });
            }
        }


    }


    function confirmarTipoDeViaje(tipo, callback) {
        Swal.fire({
            title: `¿Realmente quiere programar un viaje de tipo "${tipo}"?`,
            input: 'text',
            inputLabel: `Escriba ${tipo} para confirmar`,
            inputPlaceholder: 'Ej. ' + tipo,
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            didOpen: () => {
                const input = Swal.getInput();
                if (input) {
                  input.setAttribute('autocomplete', 'off');
                }
              },
            customClass: {
                popup: 'no-select' // esta clase la defines tú abajo
              },
            preConfirm: (inputValue) => {
                if (inputValue.trim().toLowerCase() !== tipo.toLowerCase()) {
                    Swal.showValidationMessage('El tipo de servicio no coincide.');
                    return false;
                }
            }
        }).then((result) => {
            if (result.isConfirmed && result.value.trim().toLowerCase() === tipo.toLowerCase()) {
                // Ejecuta la función si el texto coincide
                callback();
            }
        });
    }
    const limpiar = () => {
        setRuta(null)
        setCliente(null)
        setHoraInicio(null)
        setHoraFin(null)
        setEstructura(null)
        setTipoUnidad(null)
        setOperador(null)
        setMotivo("")
        setEstructuraSalida(null)
    }


    return (
        <>
            <TitleView title={"Excepciones"}></TitleView>
            <GlovalCard>
                <div className="Exepciones">
                    <div className="contenedorInputs">
                        <InputCalendario value={fecha} onChange={(e) => { setFecha(e.target.value) }} obligatorio={false} titulo={"Fecha en que se realizará el servicio"}></InputCalendario>
                        <InputLista options={clientes} value={cliente} onChange={(e) => { setCliente(e.value) }} obligatory={false} titulo={"Cliente"}></InputLista>
                        <InputLista options={rutas} value={ruta} onChange={(e) => { setRuta(e.value) }} obligatory={false} titulo={"Ruta"}></InputLista>
                        <InputLista options={estructuras} value={estructura} onChange={(e) => { setEstructura(e.value) }} obligatory={false} titulo={"Estructura"}></InputLista>
                    </div>
                    <div className="contenedorInputs">
                        <InputText value={horaInicio} onChange={(e) => { setHoraInicio(e.target.value) }} obligatorio={false} title="Inicio" type="time"></InputText>
                        <InputText value={horaFin} onChange={(e) => { setHoraFin(e.target.value) }} obligatorio={false} title="Final" type="time"></InputText>
                        <InputLista options={tipoUnidades} value={tipoUnidad} onChange={(e) => { setTipoUnidad(e.value) }} obligatory={false} titulo={"Tipo de unidad"}></InputLista>
                    </div>
                    <div className="contenedorInputs">
                        <InputLista placeholder={proveedor?.name} options={proveedores} value={proveedor} onChange={(e) => { setProveedor(e.value) }} obligatory={false} titulo={"Proveedor"}></InputLista>
                        <InputLista disabled={proveedor?.code != 1 ? true : false} options={operadores} value={operador} onChange={(e) => { setOperador(e.value) }} obligatory={false} titulo={"Operador"}></InputLista>
                        <TextArea value={motivo} onChange={(e) => { setMotivo(e.target.value) }} obligatorio titulo="Motivo"></TextArea>
                    </div>
                    <div className="contenedorInputs">

                        <div className="radios">
                            <div className="title">Tipo de servicio</div>
                            <label> <input onChange={(e) => { setTipo(e.target.value) }} checked={tipo == "Sencillo" ? true : false} type="radio" name="tipo-servicio" value={'Sencillo'} /> Sencillo </label>
                            <label> <input onChange={(e) => { setTipo(e.target.value) }} checked={tipo == "Medio" ? true : false} type="radio" name="tipo-servicio" value={'Medio'} /> Medio </label>
                        </div>
                        {
                            tipo == 'Medio' ?
                                <>
                                    <InputLista options={estructuras} value={estructuraSalida} onChange={(e) => { setEstructuraSalida(e.value) }} obligatory={false} titulo={"Estructura de salida"}></InputLista>
                                </> : ""
                        }
                        <div className="radios">
                            <div className="title">Requerido por el cliente</div>
                            <label> <input checked={requeridoCliente == 'si' ? true : false} value={'si'} onChange={(e) => { setRequeridoCliente(e.target.value) }} type="radio" name="requerido-cliente" /> Si </label>
                            <label> <input checked={requeridoCliente == 'no' ? true : false} value={'no'} onChange={(e) => { setRequeridoCliente(e.target.value) }} type="radio" name="requerido-cliente" /> No </label>
                        </div>
                        <div className="buttonProgamar">
                            <Button onClick={() => { submit() }}>Programar</Button>
                        </div>
                    </div>
                </div>
            </GlovalCard>
        </>
    )
}
export default Exepciones